import * as React from "react";

function FormsTemplates({ color = "var(--color-blue-500)", ...props }) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 22 22" fill="none" {...props}>
      <path
        d="M1.833 11.917l3.667 3.666 7.333-7.333"
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.083 14.667l.917.916 9.167-9.166"
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default FormsTemplates;
